import { useState } from "react";
import api, { formatError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Sparkles } from "lucide-react";
import { toast } from "sonner";

const AskAurea = ({ topic, placeholder }) => {
  const [desc, setDesc] = useState("");
  const [feedback, setFeedback] = useState("");
  const [loading, setLoading] = useState(false);

  const ask = async () => {
    if (!desc.trim()) { toast.info("Share a little so Aurea can respond."); return; }
    setLoading(true);
    try {
      const { data } = await api.post("/resources/assess", { topic, description: desc });
      setFeedback(data.feedback);
    } catch (err) {
      toast.error(formatError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white rounded-2xl border border-linen-3 p-5 mt-4" data-testid="ask-aurea">
      <p className="text-sm font-medium text-ink mb-2 flex items-center gap-1.5"><Sparkles className="w-4 h-4 text-brand" /> Talk to Aurea about {topic.toLowerCase()}</p>
      <Textarea value={desc} onChange={(e) => setDesc(e.target.value)} placeholder={placeholder || "Share what's happening for you…"} className="rounded-2xl bg-linen border-linen-3 min-h-[80px]" data-testid="ask-aurea-input" />
      <Button onClick={ask} disabled={loading} className="rounded-full bg-brand hover:bg-brand-hover text-linen mt-3" data-testid="ask-aurea-submit">{loading ? "Reflecting…" : "Get caring feedback"}</Button>
      {feedback && <p className="text-sm text-ink-2 leading-relaxed mt-4 whitespace-pre-wrap bg-linen-2 rounded-2xl p-4" data-testid="ask-aurea-feedback">{feedback}</p>}
    </div>
  );
};

export default AskAurea;
